import { useIntl } from 'react-intl';

import { AlertCircleIcon } from 'src/icons/AlertCircleIcon';

import styles from './DailyActionsError.module.scss';

export function DailyActionsError() {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <AlertCircleIcon stroke="#A66565" />
        <h3 className={styles.title}>
          {intl.formatMessage({
            id: 'daily-actions.error',
            defaultMessage: 'Something went wrong while loading this page, try refreshing',
          })}
        </h3>
      </div>
    </div>
  );
}
